exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd[data-v-2b029690] {\n    vertical-align: top;\n}\n.fc-event[data-v-2b029690]{\n    cursor: pointer;\n}\n", ""]);

// exports
